import type { SubjectRequirementTargetKind } from '../../services/licenseComplianceService';

/**
 * True when the hours-based ethics figure should be hidden for a license:
 * the state's ethics rule is a specific attested course (a manual subject
 * requirement row) and there is no hours target. Showing "0 ethics" next to
 * that row reads as "no ethics requirement", which is misleading — the
 * requirement exists, it just isn't hours-tracked. States with no manual
 * rows keep their explicit zero so a missing requirement stays visible.
 */
export function hideHoursBasedEthics(
  ethicsHours: number | null | undefined,
  subjectRequirements: ReadonlyArray<{ targetKind: SubjectRequirementTargetKind }>
): boolean {
  return (ethicsHours ?? 0) <= 0 && subjectRequirements.some((r) => r.targetKind === 'manual');
}
